import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "⚡", key: "underThirtyMin" },
  { emoji: "☕", key: "thirtyToSixty" },
  { emoji: "🔍", key: "oneToThreeHours" },
  { emoji: "🌀", key: "moreThanThree" },
]

export default function HomeTimeSpentPage() {
  return <RadioCardListPage translationKey="homeTimeSpent" options={OPTIONS} />
}
